// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import { Box, Flex, Stack, Text } from '@mantine/core';

import 'components/Autodesk/forge-viewer.css';
import type { BuiltInExtension } from 'components/Autodesk/extensions/useHideExtensions';
import { ForgeViewerFromModel } from 'components/Autodesk/ForgeViewerFromModel';
import { isNotNil } from 'helpers/isNotNil';

type Props = {
  headerSection?: ReactNode;
  selectedUrn: string | null;
};

const HIDDEN_EXTENSIONS = [
  'measurementSubmenu',
  'cameraSubmenu',
  'section',
  'explode',
  'bimWalk',
] as const satisfies BuiltInExtension[];

export const SpoolForgeViewerPane = ({ selectedUrn, headerSection }: Props) => (
  <Stack flex={1} gap={0}>
    <Flex justify="space-between" align="center" p="md">
      {headerSection}
    </Flex>
    <Box pos="relative" className="forge-container" flex={1}>
      {isNotNil(selectedUrn) ? (
        <ForgeViewerFromModel
          urn={selectedUrn}
          shouldInitializeAuth
          showSpoolMenu={false}
          hideExtensions={HIDDEN_EXTENSIONS}
        />
      ) : (
        <Flex c="dimmed" w="100%" h="100%" justify="center" align="center">
          <Text>Select a model to view it here.</Text>
        </Flex>
      )}
    </Box>
  </Stack>
);
